import { motion } from "framer-motion";
import { Trophy, Medal } from "lucide-react";

const QUARTERS = [["q4", "4th"], ["q3", "3rd"], ["q2", "2nd"], ["q1", "1st"]];

export const WinnerBanner = ({ board }) => {
  const latest = QUARTERS.find(([q]) => board.winners?.[q] != null);
  if (!latest) return null;
  const [q, label] = latest;
  const num = board.winners[q];
  const name = board.squares?.find((s) => s.number === num)?.name;
  return (
    <motion.div key={`${q}-${num}`} initial={{ opacity: 0, y: -16, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.5 }}
      className="relative overflow-hidden bg-gradient-to-r from-[#7a1f12] via-[#c4473d] to-[#7a1f12] border-y-2 border-[#f3c649]" data-testid="winner-banner">
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_20%_50%,#f3c649_0,transparent_35%),radial-gradient(circle_at_80%_50%,#f3c649_0,transparent_35%)]" />
      <div className="relative max-w-5xl mx-auto px-5 py-5 sm:py-7 flex items-center justify-center gap-4 sm:gap-6 text-center">
        <motion.div animate={{ rotate: [0, -12, 12, -8, 0] }} transition={{ duration: 1.2, repeat: Infinity, repeatDelay: 2 }}>
          <Trophy className="text-[#f3c649] w-9 h-9 sm:w-14 sm:h-14" />
        </motion.div>
        <div>
          <p className="font-display uppercase tracking-[0.25em] text-[#ffe9a8] text-xs sm:text-sm" data-testid="winner-banner-quarter">{label} Quarter Winner</p>
          <p className="headline text-3xl sm:text-5xl text-white leading-none mt-1" data-testid="winner-banner-name">#{num} · {name || "Winner"}</p>
          {board.payout_per_quarter > 0 && (
            <p className="font-display uppercase tracking-wide text-[#f3c649] text-sm sm:text-lg mt-1">Takes home ${board.payout_per_quarter.toLocaleString()}</p>
          )}
        </div>
        <motion.div className="hidden sm:block" animate={{ rotate: [0, 12, -12, 8, 0] }} transition={{ duration: 1.2, repeat: Infinity, repeatDelay: 2 }}>
          <Trophy className="text-[#f3c649] w-14 h-14" />
        </motion.div>
      </div>
    </motion.div>
  );
};

export const SellerLeaderboard = ({ leaders }) => {
  if (!leaders?.length) return null;
  const medal = ["text-[#f3c649]", "text-[#c9ced6]", "text-[#cd7f32]"];
  return (
    <div data-testid="seller-leaderboard">
      <h2 className="headline text-2xl text-[#f7f3ec] flex items-center gap-2 mb-1"><Medal size={20} className="text-[#f3c649]" /> Top Sellers</h2>
      <p className="text-[#8f857a] text-sm mb-3">Ryders who sold the most squares.</p>
      <div className="space-y-2">
        {leaders.map((l, i) => (
          <div key={`${l.nickname}-${i}`} className="bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 flex items-center gap-4" data-testid={`seller-row-${i}`}>
            <span className={`headline text-xl w-7 ${medal[i] || "text-[#8f857a]"}`}>{i + 1}</span>
            <span className="text-[#f7f3ec] font-display uppercase tracking-wide flex-1 truncate">{l.nickname}</span>
            <span className="headline text-xl gold-text">{l.squares}</span>
            <span className="text-[#8f857a] text-xs uppercase">{l.squares === 1 ? "square" : "squares"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
